import axios from 'services/axios'

import {
  API_ECWT_ACKNOWLEDGE,
  API_ECWT_DOWNLOAD,
  API_ECWT_INFO,
} from 'constants/endpoints'
import Ecwt from 'models/Ecwt'

/**
 * Get ecwt details
 *
 * @param {Object} { ecwtId, notificationId }
 * @returns {Object}
 */

export const getEcwtInfo = async ({ ecwtId, notificationId }) => {
  try {
    const { data } = await axios.post(
      API_ECWT_INFO,
      {},
      {
        params: {
          id: ecwtId,
          notifiId: notificationId,
        },
      }
    )

    data.pdfFile = await getPdf(data.fileName)

    return new Ecwt({
      ...data,
      id: ecwtId,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get pdf file
 *
 * @param {String} fileName
 * @return {Object}
 */
export const getPdf = async (fileName) => {
  try {
    const { data } = await axios.post(
      API_ECWT_DOWNLOAD,
      {},
      {
        params: {
          fileName,
          typeFile: 'PDF',
          isView: true,
        },
        responseType: 'blob',
      }
    )
    return data
  } catch (error) {
    return null
  }
}

/**
 * Download ecwt
 *
 * @param {String} fileName
 * @return {Object}
 */
export const downloadEcwt = async (fileName) => {
  try {
    return await axios.post(
      API_ECWT_DOWNLOAD,
      {},
      {
        params: {
          fileName,
          typeFile: 'PDF',
          isView: false,
        },
        downloadFile: true,
      }
    )
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Download ecwt supporting document
 *
 * @param {String} name
 * @return {Object}
 */
export const downloadDocument = async (fileName) => {
  try {
    return await axios.post(
      API_ECWT_DOWNLOAD,
      {},
      {
        params: {
          fileName,
          typeFile: 'XLS',
          isView: false,
        },
        downloadFile: true,
      }
    )
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Tag isAcknowledge
 *
 * @param {Number} { ecwtId }
 */

export const tagAcknowledged = async (ecwtId) => {
  try {
    await axios.post(
      API_ECWT_ACKNOWLEDGE,
      {},
      {
        params: {
          id: ecwtId,
        },
      }
    )
  } catch (error) {
    return Promise.reject(error)
  }
}
